/* @flow weak */
import { Record } from "../transit";

const State = Record(
  {
    appPath: "",
    appName: "",
    appVersion: "",
    sentryUrl: "",
    apiHost: ""
  },
  "config"
);

const configReducer = (state = new State()) => state;

export default configReducer;



// WEBPACK FOOTER //
// ./src/common/config/reducer.js